import {Component} from '@angular/core';

import {AlertaModel} from '../Modelo/Alerta.model';
import {MensajeService} from '../Mensaje.Service';
import {AlertaEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';


@Component(
{
  selector: 'alerta',
  templateUrl: './Alerta.template.html',
  styleUrls: ['./Alerta.scss'],
})

export class AlertaComponent
{
  alerta:Array<AlertaModel> = [];

  timer : any;
  descripcionBase : string = "";
  finTimer : any;

  constructor(private mensajeService: MensajeService)
  {
  }

  ngOnInit()
  {
    this.mensajeService.IniciarAlerta().subscribe((alerta: AlertaModel) =>
    {
      if (!alerta)
      {
        this.alerta = [];
        return;
      }
      else
      {
        this.SetDatosAlerta(alerta);
        this.ValidarAlertaExistente(alerta);

        this.alerta.push(alerta);

        if(alerta.Remove)
        {
          setTimeout(() => this.RemoveAlerta(alerta), 5000);
        }
      }
    });
  }

  SetDatosAlerta(alerta : AlertaModel)
  {
    switch (alerta.Tipo)
    {
      case AlertaEnum.Success:
        alerta.Icono = "fa fa-check";
        alerta.Clase = "success"
        break;

      case AlertaEnum.Warning:
        alerta.Icono = "fa fa-exclamation-triangle";
        alerta.Clase = "warning"
        break;

      case AlertaEnum.Error:
        alerta.Icono = "fa fa-exclamation-triangle";
        alerta.Clase = "error"
        break;

      case AlertaEnum.Informacion:
        alerta.Icono = "fa fa-info";
        alerta.Clase = "informacion"
        break;

      default:
        break;
    }

    alerta.Animacion = "slideInUp";
  }

  ValidarAlertaExistente(alerta : AlertaModel)
  {
    for(let k=0; k<this.alerta.length; k++)
    {
      if(this.alerta[k].Descripcion == alerta.Descripcion && this.alerta[k].Tipo == alerta.Tipo)
      {
        this.RemoveAlerta(this.alerta[k], false);
      }
    }
  }

  RemoveAlerta(alerta : AlertaModel, animacion = true)
  {
    if (animacion)
    {
      alerta.Animacion = "slideOutDown rapido";

      setTimeout(() =>
      {
        this.alerta = this.alerta.filter(p => p.AlertaId !== alerta.AlertaId);
      }, 310);
    }
    else
    {
      this.alerta = this.alerta.filter(p => p.AlertaId !== alerta.AlertaId);
    }
  }
}
